import { render } from "./TestimonialContent.vue?vue&type=template&id=d924d914&scoped=true&ts=true"
import script from "./TestimonialContent.vue?vue&type=script&lang=ts"
export * from "./TestimonialContent.vue?vue&type=script&lang=ts"

import "./TestimonialContent.vue?vue&type=style&index=0&id=d924d914&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d924d914"]])

export default __exports__